export default __webpack_public_path__ + "static/universal-menu-2-7990063e6d81fa855eb3b06391033638.jpg";